module.exports = __webpack_public_path__ + "static/img/pa3.f60e793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/pa3.png
// module id = 4k2U
// module chunks = 0